export class Globals
{
  public static mode: string;
}
